import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useProductsStore } from "../../store/products.store";

export const useProducts = () => {
  const setProducts = useProductsStore((state) => state.setProducts);

  return useMutation(PartnerApi.vendorProducts, {
    onSuccess: (data) => {
      setProducts(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
